import cloneDeep from "lodash.clonedeep";

export const setChartStyle = (state, variables) => {
  const colors = {};

  if (state.theme === "dark-theme") {
    colors.bg = variables.primaryBgDt;
    colors.bgRevers = variables.primaryBgLt;
    colors.text = variables.additionalTextLt;
  } else {
    colors.bg = variables.primaryBgLt;
    colors.bgRevers = variables.primaryBgDt;
    colors.text = variables.additionalTextDt;
  }

  state.chartOption.textStyle = { color: colors.text };
  if (state.chartOption.legend)
    state.chartOption.legend.textStyle = {
      color: colors.text,
      fontSize: 10
    };

  if (state.chartOption.series[0].itemStyle && state.type === "type-4")
    state.chartOption.series[0].itemStyle = {
      borderWidth: 3,
      borderColor: colors.bg
    };
};

export const setChartOptions = state => {
  switch (state.type) {
    case "type-1":
      setBasicChart(state);
      break;
    case "type-2":
      setBarChart(state);
      break;
    case "type-3":
      setBarXChart(state);
      break;
    case "type-4":
      setPieChart(state);
      break;
  }
};

const setBasicChart = state => {
  if (state.chartData && state.chartData.data) {
    const chartData = state.chartData.data.map(e => {
      return {
        name: state.$t(e.dataTitle),
        type: "line",
        stack: "one",
        areaStyle: {
          color: e.color,
          opacity: 0.6
        },
        lineStyle: {
          width: 1,
          color: e.color
        },
        itemStyle: {
          color: e.color,
          borderColor: e.color
        },
        smooth: true,
        data: e.data,
        symbol: "none",
        showSymbol: false,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: e.color
            }
          }
        }
      };
    });

    const chartOptions = cloneDeep(state.basic);

    if (!state.noLegend) {
      chartOptions.legend.data = state.chartData.data.map(e =>
        state.$t(e.dataTitle)
      );
    }
    chartOptions.series = chartData;
    chartOptions.xAxis[0].data = state.chartData.xAxis.data;
    state.chartOption = cloneDeep(chartOptions);
  } else {
    state.chartOption = cloneDeep(state.basic);
    if (state.noLegend) {
      delete state.chartOption.legend;
    }
  }
};

const setBarChart = state => {
  if (state.chartData && state.chartData.data) {
    const chartData = state.chartData.data.map(e => {
      return {
        name: state.$t(e.dataTitle),
        type: "bar",
        stack: "first",
        data: e.data,
        color: e.color
      };
    });

    const chartOptions = cloneDeep(state.bar);

    if (!state.noLegend) {
      chartOptions.legend.data = state.chartData.data.map(e =>
        state.$t(e.dataTitle)
      );
    }

    if (state.dataZoom) {
      chartOptions.dataZoom = [
        {
          type: "slider",
          start: 0,
          end: 25
        },
        {
          type: "inside",
          start: 0,
          end: 25
        }
      ];
      chartOptions.grid.bottom = 60;
    }
    chartOptions.series = chartData;
    chartOptions.xAxis.data = state.chartData.xAxis.data;
    state.chartOption = cloneDeep(chartOptions);
  } else {
    state.chartOption = cloneDeep(state.bar);
    if (state.noLegend) {
      delete state.chartOption.legend;
    }
  }
};

const setBarXChart = state => {
  if (state.chartData && state.chartData.data) {
    const chartLegend = state.chartData.data.map(e => state.$t(e.dataTitle));
    const chartData = state.chartData.data.map(e => {
      return {
        name: state.$t(e.dataTitle),
        type: "bar",
        stack: "first",
        data: e.data,
        color: e.color
      };
    });

    const chartOptions = cloneDeep(state.barX);

    chartOptions.legend.data = chartLegend;
    chartOptions.series = chartData;
    chartOptions.yAxis.data = state.chartData.xAxis.data;
    state.chartOption = cloneDeep(chartOptions);
  } else {
    state.chartOption = cloneDeep(state.barX);
    if (state.noLegend) {
      delete state.chartOption.legend;
    }
  }
};

const setPieChart = state => {
  if (state.chartData && state.chartData.data) {
    const chartLegend = state.chartData.data.map(e => state.$t(e.dataTitle));
    const chartData = state.chartData.data.map(e => {
      return {
        name: state.$t(e.dataTitle),
        value: e.data.reduce(function(sum, current) {
          return sum + current;
        }, 0)
      };
    });

    const chartOptions = cloneDeep(state.pie);

    chartOptions.legend.data = chartLegend;
    chartOptions.series[0].data = chartData;
    state.chartOption = cloneDeep(chartOptions);
  } else {
    state.chartOption = cloneDeep(state.pie);
    if (state.noLegend) {
      delete state.chartOption.legend;
    }
  }
};
